import { Observable, of } from 'rxjs';
import { LogEntry } from './log-entry';
import { LogLevel } from './log-level.enum';
import { LogPublisher } from './log-publisher';

export class LogConsole extends LogPublisher {

    log(entry: LogEntry): Observable<boolean> {
        // Log to console

        switch (entry.level) {
            case LogLevel.Debug:
                console.debug(entry);
                break;
            case LogLevel.Warn:
                console.warn(entry.buildLogString(this.decycleLib));
                break;
            case LogLevel.Error:
                console.error(entry.buildLogString(this.decycleLib));
                break;

            default:
                console.log(entry.buildLogString(this.decycleLib));
        }

        return of(true);
    }

    clear(): Observable<boolean> {
        console.clear();
        return of(true);
    }
}
